import React from 'react';
import { GetUniversityStudentStatsAPIResponse } from 'types';

interface StatsCardProps {
	data: GetUniversityStudentStatsAPIResponse;
}

const StatsCard = ({
	data: {
		aiInterViewTakenUsers,
		automatedInterViewTakenUsers,
		aiAndAutomatedInterviewUsers,

		aiInterViewAttemptedUsers,
		automatedInterViewAttemptedUsers,
		aiAndAutomatedInterviewAttemptedUsers,
		totalUsers,
		mockTestTakers,
		mandatoryFormFilledUsers,
		bothFormFilledUsers,
		optionalFormFilledUsers,
	},
}: StatsCardProps) => {
	const assessments = [
		{ name: 'L1: AI Interview', score: aiInterViewTakenUsers },
		{ name: 'L2: Assessment Test', score: automatedInterViewTakenUsers },
	];

	const attemptedAssessments = [
		{ name: 'L1: AI Interview', score: aiInterViewAttemptedUsers },
		{ name: 'L2: Assessment Test', score: automatedInterViewAttemptedUsers },
	];
	const completedProfiles = [
		{ name: 'Pre Test Form', score: mandatoryFormFilledUsers },
		{ name: 'Post Test Form', score: optionalFormFilledUsers },
	];

	return (
		<div className="flex overflow-auto flex-col gap-8 m-auto justify-start py-8 md:py-12 md:flex-row">
			<section className="flex flex-col gap-2 px-6 py-4 text-xs bg-white rounded-2xl w-full min-w-[200px] text-zinc-900">
				<header className="flex gap-2 items-center w-full text-sm font-semibold leading-none rounded-lg text-slate-600">
					<h2 className="flex-1 shrink self-stretch my-auto w-full text-sm font-[600] font-inter">Total Students</h2>
				</header>
				<div className="flex gap-2 justify-between items-center mt-2 w-full text-2xl font-inter font-semibold whitespace-nowrap rounded-lg text-zinc-900">
					<span className="self-stretch my-auto w-[62px]">{totalUsers?.toLocaleString()}</span>
				</div>
			</section>

			<section className="flex flex-col gap-2 px-6 py-4 text-xs bg-white rounded-2xl w-full min-w-[200px] text-zinc-900">
				<header className="flex gap-2 items-center w-full text-sm font-semibold leading-none rounded-lg text-slate-600">
					<h2 className="flex-1 shrink self-stretch my-auto w-full text-sm font-[600] font-inter">Mock Test Takers</h2>
				</header>
				<div className="flex gap-2 justify-between items-center mt-2 w-full text-2xl font-inter font-semibold whitespace-nowrap rounded-lg text-zinc-900">
					<span className="self-stretch my-auto w-[62px]">{mockTestTakers?.toLocaleString()}</span>
				</div>
			</section>

			<section className="flex flex-col gap-2 px-6 py-4 text-xs bg-white rounded-2xl w-full min-w-[200px] text-zinc-900">
				<header className="flex gap-2 items-center w-full text-sm font-semibold leading-none rounded-lg text-slate-600">
					<h2 className="flex-1 shrink self-stretch my-auto w-full text-sm font-[600] font-inter">
						Completed Profiles
					</h2>
				</header>
				<div className="flex gap-2 justify-between items-center mt-2 w-full text-2xl font-inter font-semibold whitespace-nowrap rounded-lg text-zinc-900">
					<span className="self-stretch my-auto w-[62px]">{bothFormFilledUsers?.toLocaleString()}</span>
				</div>
				{completedProfiles?.map(profile => (
					<div key={profile.name} className="flex gap-1 items-center w-full leading-loose rounded-lg min-h-[20px]">
						<div className="self-stretch my-auto rounded-lg w-[170px]">{profile.name}</div>
						<div className="flex-1 shrink self-stretch my-auto font-semibold text-right whitespace-nowrap rounded-lg">
							{profile.score?.toLocaleString()}
						</div>
					</div>
				))}
			</section>

			<section className="flex flex-col gap-2 px-6 py-4 text-xs bg-white rounded-2xl w-full min-w-[200px] text-zinc-900">
				<header className="flex gap-2 items-center w-full text-sm font-semibold leading-none rounded-lg text-slate-600">
					<h2 className="flex-1 shrink self-stretch my-auto w-full text-sm font-[600] font-inter">
						Started Assessment
					</h2>
				</header>

				<div className="flex gap-2 justify-between items-center mt-2 w-full text-2xl font-inter font-semibold whitespace-nowrap rounded-lg text-zinc-900">
					<span className="self-stretch my-auto w-[62px]">
						{aiAndAutomatedInterviewAttemptedUsers?.toLocaleString()}
					</span>
				</div>
				{attemptedAssessments.map((assessment, index) => (
					<div key={index} className="flex gap-1 items-center w-full leading-loose rounded-lg min-h-[20px]">
						<div className="self-stretch my-auto rounded-lg w-[170px]">{assessment.name}</div>
						<div className="flex-1 shrink self-stretch my-auto font-semibold text-right whitespace-nowrap rounded-lg">
							{assessment.score?.toLocaleString()}
						</div>
					</div>
				))}
			</section>
			<section className="flex flex-col gap-2 px-6 py-4 text-xs bg-white rounded-2xl w-full min-w-[200px] text-zinc-900">
				<header className="flex gap-2 items-center w-full text-sm font-semibold leading-none rounded-lg text-slate-600">
					<h2 className="flex-1 shrink self-stretch my-auto w-full text-sm font-[600] font-inter">
						Completed Assessment
					</h2>
				</header>
				<div className="flex gap-2 justify-between items-center mt-2 w-full text-2xl font-inter font-semibold whitespace-nowrap rounded-lg text-zinc-900">
					<span className="self-stretch my-auto w-[62px]">{aiAndAutomatedInterviewUsers?.toLocaleString()}</span>
				</div>
				{assessments.map((assessment, index) => (
					<div key={index} className="flex gap-1 items-center w-full leading-loose rounded-lg min-h-[20px]">
						<div className="self-stretch my-auto rounded-lg w-[170px]">{assessment.name}</div>
						<div className="flex-1 shrink self-stretch my-auto font-semibold text-right whitespace-nowrap rounded-lg">
							{assessment.score?.toLocaleString()}
						</div>
					</div>
				))}
			</section>
		</div>
	);
};

export default StatsCard;
